import React, { Component } from 'react'
import Arrow3Svg from '../icons/Arrow3Svg';

export class Card2 extends Component {
    render() {
        const { image, text, className, shadow } = this.props;
        return (
            <div className={`${className} ${shadow}  rounded-[8px] flex flex-col gap-[24px] p-[24px] animation-card group max-[400px]:gap-[16px] max-[400px]:p-[19px]`}>
                {/* */}
                <div className='w-[80px] h-[80px] flex items-center justify-center rounded-[50px] bg-[#f4f8fc] back-white '>
                    {this.props.icon}
                </div>

                <h3 className='text-[20px] font-[700] text-[#000] max-[600px]:text-[18px] '>{this.props.title}</h3>

                <p className='text-[#676879] font-[400] text-[16px] max-[600px]:text-[15px] '>
                    {text}
                </p>

                {/* <div className='flex items-center gap-[4px]'>
                    <span className='font-[600] text-[18px] text-[#000] max-[600px]:text-[16px] '> Learn More </span>
                    <Arrow3Svg className=" stroke-[#000] group-hover:stroke-[#fff]" />
                </div> */}
            </div>

        )
    }
}

export default Card2